// api.ts
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import api from "../../../../../../features/auth/axiosConfig";
import { CustomerFormData } from "../types";

interface ApiErrorResponse {
  message?: string;
}

export const handleUpdateError = (error: AxiosError<ApiErrorResponse>) => {
  const errorMessage =
    error.response?.data?.message || "Error updating customer. Please try again.";

  if (errorMessage.includes("Email already exists")) {
    toast.error("Email already exists", { theme: "colored", autoClose: 2000 });
  } else if (errorMessage.includes("Phone Number already exists")) {
    toast.error("Phone Number already exists", { theme: "colored", autoClose: 2000 });
  } else {
    toast.error(errorMessage, { theme: "colored", autoClose: 2000 });
  }
};

export const updateCustomerApi = async (
  id: string | number,
  formData: CustomerFormData,
  onSuccess: () => void
) => {
  const payload = {
    Name: formData.name,
    phone_number: formData.phoneNumber,
    alternativenumber: formData.alternativePhone,
    Email: formData.email,
    Address: {
      customeraddress1: formData.address1,
      customeraddress2: formData.address2,
      customeraddress3: formData.address3,
    },
  };

  const res = await api.put(`/app/v1/pos/customer/${id}`, payload);

  if (res.status === 200 || res.status === 201) {
    toast.success("Customer updated successfully", {
      position: "top-right",
      autoClose: 2000,
      theme: "colored",
    });
    onSuccess();
  }
};
